//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'dayjs/locale/nl'
import 'dayjs/locale/en'
import 'vue2-datepicker/locale/nl'
import 'vue2-datepicker/locale/en'

export default {
  name: 'LanguageSelector',
  computed: {
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languages() {
      return this.$store.get('language/locales')
    }
  },
  beforeMount() {
    const lang = this.$route.query.lang?.toLowerCase()
    switch (lang) {
      case 'eng':
        this.onLanguageSelect(this.languages.find((x) => x.code === 'en'))
        break
      case 'nld':
        this.onLanguageSelect(this.languages.find((x) => x.code === 'nl'))
    }
  },
  methods: {
    onLanguageSelect(language) {
      this.$root.$i18n.setLocale(language.code)
      this.$dayjs.locale(language.code)
      this.$store.set('language/locale', language.code)
      this.$store.set('language/hasManuallyChanged', true)

      this.$nuxt.$emit('language-change', language)
    }
  }
}
